import React from 'react'

function DisableUser() {
  return (
    <div>
      <p>
        user disabled
      </p>
    </div>
  )
}

export default DisableUser
